import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [AuthService]
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  errorMessage: string;
  auth : any = {};
  user:any = {};
  shopName:String;
  hideDropdown:boolean=true;
  constructor(private authService: AuthService, private router: Router) { }
  
  ngOnInit() {
    if (JSON.parse(localStorage.getItem('user')) != null){
      this.user = JSON.parse(localStorage.getItem('user'));
    }
    if (localStorage.getItem('shop') != null){
      this.shopName = localStorage.getItem('shopName');
    }
  }


  logout() {
    this.authService.logout()
    .subscribe(
      () => {
        this.router.navigate(['/login']);
      },
      error =>  {
        this.errorMessage = <any>error;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/common/components/header/header.component.ts